import Bars from '@engine/features/dashboard/chart/dashboard_chart_bars';
import Details from '@engine/features/dashboard/chart/dashboard_chart_details';
import FetchDataset from '@engine/features/dashboard/chart/dashboard_chart_fetch';
import Slider from '@engine/features/dashboard/chart/dashboard_chart_slider';
import Util from '@engine/features/dashboard/chart/dashboard_chart_utility';
import { exists } from '@engine/lib/utility/exists';

function DashboardBars() {
  var full_dataset = Util.dataset();

  function onSliderUpdate(_values, _handle, range_timestamps) {
    var dataset = Util.sliceDataset(full_dataset, range_timestamps);
    Bars.forceUpdate(dataset);
    Details.forceUpdate(dataset);
  }

  function fetchDataset() {
    FetchDataset.fetch('/dashboard/chart', {
      currency: Util.currency()
    }, function (response) {
      full_dataset = response;
      Slider.emitUpdateEvent();
    }, $('.dashboard-chart').parent());
  }

  function initDashboardBarsComponents() {
    // Initialize Bars
    Bars.create(full_dataset); // Initialize Slider

    Slider.create($('.dashboard-chart-slider')[0]);
    Slider.onUpdate(onSliderUpdate); // Force update all components

    Slider.emitUpdateEvent();
  }

  function initialize() {
    if (!exists($('#dashboard-chart'))) {
      return;
    } // Initialize all components (Bars, Slider, Details)


    initDashboardBarsComponents(); // Fetch real data and update all UI components

    fetchDataset(); // Update on currency change

    $('#chart-currency').on('change', function () {
      fetchDataset();
    });
  }

  return {
    initialize: initialize
  };
}

var initDashboardBarsComponents = new DashboardBars();
export default initDashboardBarsComponents;